import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SnackerService } from 'src/app/shared/snacker.service';
import { Observable } from 'rxjs';
import { StorageEnum } from 'src/models/others/StorageEnum';
import { WebserviceService } from 'src/services/webservice';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private webservice: WebserviceService,
    private snacker: SnackerService){ }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (sessionStorage.getItem(StorageEnum.getPersonName)) {  
        return true;  
    }  
    this.webservice.navigateToLogin()
    this.snacker.error("Please login");
    return false; 
  }
  
}
